﻿// This utility formats a data-testid string for UI controls.
// It takes a label and a control type, replaces whitespace with hyphens,
// strips special characters, converts to lowercase, and appends the control type.
// Example: formatDataTestId('Download Report', 'button') returns 'download-report-button'
export const formatDataTestId = (
  label: string,
  control:
    | 'button'
    | 'datePicker'
    | 'selectInput'
    | 'button-dropdown'
    | 'textInput'
    | 'checkboxInput'
    | 'radioInput'
    | 'textArea'
    | 'phone-input'
    | 'div',
) => {
  return (
    label
      .replace(/\s+/g, '-') // Replace whitespace with hyphens
      .replace(/[^a-zA-Z0-9-]/g, '') // Remove special characters
      .toLowerCase() +
    '-' +
    control
  );
};
